export default __webpack_public_path__ + "static/media/Metropolis-Regular.14b28574.woff2";